// technical debt: think about accesibility, disaggregate components and its responsabilities (!)

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'motion/react'
import { useSelectedMenuStore } from 'store'
import { scoreColors } from 'constants/creditScore'
import DesktopMenu from './DesktopMenu'
import Header from './Header'
import TabBar from './TabBar'

interface PageWrapperProps {
  children: JSX.Element
  title: string
  isSectionHome?: boolean
  mobileHeaderColor?: keyof typeof scoreColors
  className?: string
  viewSelected?: string
  forcedBackNavigation?: () => void
  noTabBar?: boolean
  noHeader?: boolean
  hasBackButton?: boolean
}

const PageWrapper = ({
  children,
  title,
  isSectionHome = false,
  mobileHeaderColor = 'default',
  className = '',
  forcedBackNavigation = null,
  viewSelected,
  noTabBar = false,
  noHeader = false,
  hasBackButton = true
}: PageWrapperProps) => {
  const { updateSelectedMenu } = useSelectedMenuStore()
  const { pathname } = useLocation()

  // TODO: think another way to mark the selected route.

  useEffect(() => {
    if (viewSelected) {
      updateSelectedMenu(viewSelected)
    } else if (pathname) updateSelectedMenu(pathname)
  }, [])

  return (
    <div className='min-h-full'>
      <DesktopMenu />
      <div className='md:ml-[5.375rem]'>
        {!noHeader ? (
          <Header
            hasBackButton={hasBackButton}
            isSectionHome={isSectionHome}
            title={title}
            mobileHeaderColor={mobileHeaderColor}
            forcedBackNavigation={forcedBackNavigation}
          />
        ) : null}
        <AnimatePresence>
          <motion.main
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -10, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className={`w-full h-full py-[4.5rem] px-4 ${className}`}
          >
            {children}
          </motion.main>
        </AnimatePresence>
        {noTabBar ? null : <TabBar />}
      </div>
    </div>
  )
}

export default PageWrapper
